import styled from 'styled-components';

// Separators 
export const StyledVerticalSeparator = styled.div`
    border-left: 2px solid #ddd;
    margin-top: 30px;    
`;

export const StyledDashedSeparator = styled.div`
    border-bottom: 2px dashed #ddd;
    margin-top: 30px;
`;

export const StyledHorizontalSeparator = styled.div`
    border-bottom: 2px solid #ddd;
    margin-left: 20px;
    margin-top: 15px;
`;

